<template>
    <!-- <b-card style=""> -->
        <!-- <b-row> -->
          <b-col col-lg-6 col-sm-12>

            <b-card>
              <h4 class="card-header">Reset Password</h4>
              <!-- <d-row> -->
                <div class="row">
                  <div class="col-lg-12 col-12">
                    <div class="form-group">
                      <label for="oldpassword">Old Password</label>
                      <input type="password" class="form-control" placeholder="Old Password" name="oldpassword" id="oldpassword" v-model="oldpassword" autocomplete='false'>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-6 col-12">
                    <div class="form-group">
                      <label for="newpassword">New Password</label>
                      <input type="password" class="form-control" placeholder="Enter New Password" name="newpassword" id="newpassword" v-model="newpassword">
                    </div>
                  </div>
                  <div class="col-lg-6 col-12">
                    <div class="form-group">
                      <label for="repeatnewpassword">Repeat New Password</label>
                      <input type="password" class="form-control" placeholder="Repeat New Password" name="repeatnewpassword" id="repeatnewpassword" v-model="repeatnewpassword">
                    </div>
                  </div>
                </div>
                <div class="col-12 d-flex flex-sm-row flex-column mt-2">
                  <button type="submit" class="btn btn-primary mb-1 mb-sm-0 mr-0 mr-sm-1" v-on:click="updateNewpassword">Save Changes</button>
                </div>
              <!-- </d-row> -->
            </b-card>

          </b-col>

          <!-- <b-col cols="6">
            <b-card>
              <h4 class="card-header">Deactivate Account</h4>
              <d-row>
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="reasonfordeactivate">Reason For Deactivate</label>
                    <input type="text" class="form-control" placeholder="Reason For Deactivate" name="reasonfordeactivate" id="reasonfordeactivate" v-model="reasonfordeactivate">
                  </div>
                </div>
                <div class="col-12 d-flex flex-sm-row flex-column mt-2">
                  <button type="submit" class="btn btn-primary mb-1 mb-sm-0 mr-0 mr-sm-1" v-on:click="deactivateAccount">Deactivate Account</button>
                </div>
              </d-row>
            </b-card>
          </b-col> -->
        <!-- </b-row> -->
    <!-- </b-card> -->
    <!-- deactivate -->
    <deactivate-account-reasons-modal :id="`deactivate-reason-modal`" />
  <!-- end deactivate -->
</template>
<script>
import DeactivateAccountReasons from '../../modals/DeactivateAccountReasons.vue'
import { useUserStore } from '../../../stores/UserStore.js'
import {BCard,BRow,BCol} from 'bootstrap-vue-3'
  export default{
    name:'UserActivityTimeline',
    components:{
        "deactivate-account-reasons-modal": DeactivateAccountReasons
    },
    data(){
      return{
        oldpassword:'',
        newpassword:'',
        repeatnewpassword:'',
        userId:'',
        reasonfordeactivate:'',
        baseUrl: baseUrl
      }
    },
    setup(){
        return {
            userStore: useUserStore(),
        }
    },
    created(){
    //   this.getUser();
    },
    watch: {
        'userStore.profile'(value) {
            this.setUserInformation(value);
        },  
    },
    mounted(){
        let $this = this;
        if (document.readyState === "complete") {
            setTimeout(() => {
                this.$nextTick(() => {
                    if(!_.isEmpty(this.userStore.profile)){
                        $this.setUserInformation(this.userStore.profile);
                    }else{
                        $this.userStore.fetchUserProfile();
                    }
                });
            }, 2000);
        } else {
            window.addEventListener("load", () => {
                setTimeout(() => {
                    this.$nextTick(() => {
                        if(!_.isEmpty(this.userStore.profile)){
                            $this.setUserInformation(this.userStore.profile);
                        }else{
                            $this.userStore.fetchUserProfile();
                        }
                    });
                }, 2000);
            });
        }
    },
    methods:{
        setUserInformation(data){
        
          this.userId = data.user.id;

      },
      updateNewpassword(){
        if(this.oldpassword != "" && this.newpassword != "" && this.repeatnewpassword != ""){
              let params ={
                current_password:this.oldpassword,
                new_password:this.newpassword,
                new_password_confirmation:this.repeatnewpassword
              }
              axios.put(`${this.baseUrl}/account/${this.userId}/changedPassword`,params).then(({data})=>{
                toastr.success(data.message,'success');
                this.oldpassword =""
                this.newpassword =""
                this.repeatnewpassword =""
              }).catch(error=>{
                let errors = error.response.data.errors;
                this.erroDisplay(errors);
              });

        }else{
          toastr.error("field can not be empty",'error');
        }
      },
      erroDisplay(error){
        for (const [key, value] of Object.entries(error)) {
          toastr.error(value,'error');
        }
      }
    }
  }
</script>
